import { useQuery } from "@tanstack/react-query";
import type { Point } from "geojson";
import { useInfrastructureApiClient } from "../../hooks";

/**
 * Sites a detection can be linked to: the nearest ones to `center`.
 */
export const useNearbySites = (center: Point | null, search?: string) => {
    const infrastructureApiClient = useInfrastructureApiClient();
    const [longitude, latitude] = center?.coordinates ?? [];

    return useQuery({
        queryKey: ["unmatchedNearbySites", latitude, longitude, search || ""],
        enabled: !!center,
        queryFn: async () => {
            const response =
                await infrastructureApiClient.infrastructureSitesList({
                    distanceTo: `${latitude},${longitude}`,
                    ordering: "distance",
                    pageSize: 15,
                    search: search || undefined,
                });
            return response.results;
        },
    });
};
